import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

export const MisionVision = () => {
  const { t } = useLang();
  const blocks = [
    { ...t.values.mission, accent: "border-ser-purple" },
    { ...t.values.vision, accent: "border-ser-blue" },
  ];
  return (
    <section className="py-14 md:py-20 border-t border-navy/5" data-testid="mission-vision-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
        {blocks.map((b, i) => (
          <Reveal key={b.title} delay={0.08 * i}>
            <div className={`border-t-2 ${b.accent} pt-8`} data-testid={`value-block-${i === 0 ? "mission" : "vision"}`}>
              <h2 className="font-display text-3xl md:text-4xl tracking-tight text-navy">{b.title}</h2>
              <p className="mt-6 text-base md:text-lg leading-relaxed text-navy/75">{b.p1}</p>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-navy/65">{b.p2}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export const ConsultancyWay = () => {
  const { t } = useLang();
  return (
    <section className="bg-pastel-violet py-16 md:py-24" data-testid="consultancy-way-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <h2 className="font-display text-3xl md:text-5xl leading-[1.1] tracking-tight text-navy max-w-2xl">
            {t.values.way.title}
          </h2>
          <span className="block h-px w-16 bg-ser-yellow mt-8" aria-hidden="true" />
          <p className="mt-8 text-base md:text-lg leading-relaxed text-navy/80">{t.values.way.p1}</p>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-navy/80">{t.values.way.p2}</p>
        </Reveal>
      </div>
    </section>
  );
};

export const SerPrinciples = () => {
  const { t } = useLang();
  return (
    <section className="py-14 md:py-20" data-testid="ser-principles-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline>{t.values.principles.closing}</Overline>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.08] tracking-tight text-navy mt-4">
            {t.values.principles.title}
          </h2>
        </Reveal>

        <div className="mt-12">
          {t.values.principles.items.map((p, i) => (
            <Reveal key={p.title} delay={0.05 * i}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 py-10 border-t border-navy/10 last:border-b" data-testid={`principle-${p.title.toLowerCase()}`}>
                <div className="md:col-span-4 flex items-baseline gap-5">
                  <span className="font-display text-4xl md:text-5xl leading-none text-ser-purple/25" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-display text-2xl md:text-3xl text-navy">{p.title}</h3>
                </div>
                <div className="md:col-span-8 space-y-4">
                  {p.p.map((par) => (
                    <p key={par.slice(0, 32)} className="text-sm md:text-base leading-relaxed text-navy/70 max-w-2xl">
                      {par}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-16 text-center font-display italic text-2xl md:text-4xl text-navy" data-testid="principles-closing">
            {t.values.principles.closing}
          </p>
          <p className="mt-5 text-center text-sm md:text-base text-navy/60 max-w-xl mx-auto">
            {t.values.principles.closingText}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
